import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'

function MatchTableComponent(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onValueChange,
    onAttemptChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    handleSucAndFailFeedback
  } = props

  const {
    ControlID,
    Answers,
    Score,
    AnswerColorFill,
    QuestionFontSize,
    AnswerFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    SequenceHint,
    ColQuestion,
    RowAnswer,
    Type,
    QuestionFillColor,
    TextAlign,
    FontStyle,
    Italic,
    Bold
  } = mcData
  const [selectedAnswerArray, setSelectedAnswerArray] = useState([])

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue.CtlValue) {
        setSelectedAnswerArray(defaultValue.CtlValue)
      } else {
        let defaultAnswerArrayCopy = []
        if (Type === 'Multiple choice') {
          RowAnswer.map(() => {
            defaultAnswerArrayCopy.push([undefined])
          })
        } else {
          RowAnswer.map(() => {
            let colAnswerArrayCopy = []
            ColQuestion.map(() => {
              colAnswerArrayCopy.push(undefined)
            })
            defaultAnswerArrayCopy.push(colAnswerArrayCopy)
          })
        }
        setSelectedAnswerArray(defaultAnswerArrayCopy)
      }
    } else {
      let defaultAnswerArrayCopy = []
      if (Type === 'Multiple choice') {
        RowAnswer.map(() => {
          defaultAnswerArrayCopy.push([undefined])
        })
      } else {
        RowAnswer.map(() => {
          let colAnswerArrayCopy = []
          ColQuestion.map(() => {
            colAnswerArrayCopy.push(undefined)
          })
          defaultAnswerArrayCopy.push(colAnswerArrayCopy)
        })
      }
      setSelectedAnswerArray(defaultAnswerArrayCopy)
    }
  }, [defaultValue])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, selectedAnswerArray)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    //Filter selectedAnswer for validation
    if (defaultValue && defaultValue.CtlScore) {
      if (defaultValue.CtlScore === Score) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  function handleOptionChange(rowIndex, colIndex, selectedValue) {
    let selectedAnswerArrayCopy = [...selectedAnswerArray]
    let isChecked = false
    if (Type === 'Multiple choice') {
      if (selectedAnswerArrayCopy[rowIndex][0] !== selectedValue) {
        onAttemptChange(1)
        selectedAnswerArrayCopy[rowIndex][0] = selectedValue
        isChecked = true
      }
    } else {
      if (selectedAnswerArrayCopy[rowIndex][colIndex]) {
        selectedAnswerArrayCopy[rowIndex][colIndex] = undefined
        isChecked = false
      } else {
        onAttemptChange(1)
        selectedAnswerArrayCopy[rowIndex][colIndex] = selectedValue
        isChecked = true
      }
    }
    setSelectedAnswerArray(selectedAnswerArrayCopy)
    validateCorrectAnswer(false, selectedAnswerArrayCopy)
    if (isPractice && isChecked) {
      let correctOrWrong = Answers[rowIndex].includes(selectedValue)
      if (correctOrWrong) {
        handleSuccessChange(true)
      } else {
        handleSuccessChange(false)
      }
    }
  }

  function validateCorrectAnswer(timerValue, selectedAnswerArrayCopy) {
    //Filter selectedAnswer for validation
    let befrSortedselectedCopy = []
    for (let index = 0; index < selectedAnswerArrayCopy.length; index++) {
      let selectedAnswerCopy = []
      selectedAnswerArrayCopy[index].map((colItem, colIndex) => {
        if (colItem !== undefined && colItem !== null) {
          selectedAnswerCopy.push(colItem)
        }
      })
      befrSortedselectedCopy.push(selectedAnswerCopy)
    }

    //Check all the answers are attend
    let correct = false
    for (let ci = 0; ci < befrSortedselectedCopy.length; ci++) {
      if (befrSortedselectedCopy[ci].length > 0) {
        correct = true
      } else {
        correct = false
        break
      }
    }

    //sorted selected array
    let selectedCopy = []
    befrSortedselectedCopy.map((selectedItem, selectedIndex) => {
      const srtArray = [...selectedItem].sort((a, b) => (a > b ? 1 : -1))
      selectedCopy.push(srtArray)
    })

    //sorted Answer array
    let sortedAnswerCopy = []
    Answers.map((selectedItem, selectedIndex) => {
      const srtAnswerArray = [...selectedItem].sort((a, b) => (a > b ? 1 : -1))
      sortedAnswerCopy.push(srtAnswerArray)
    })

    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (JSON.stringify(selectedCopy) === JSON.stringify(sortedAnswerCopy)) {
          onPriorityChange(Priority)
        }
      } else {
        if (correct) {
          onPriorityChange(Priority)
        }
      }
    }

    let currentScore = 0
    selectedCopy.map((selectedItem, selectedIndex) => {
      if (
        JSON.stringify(selectedItem) ===
        JSON.stringify(sortedAnswerCopy[selectedIndex])
      ) {
        currentScore += Score / RowAnswer.length
      }
    })

    onValueChange(
      ControlID,
      selectedAnswerArray,
      currentScore,
      Score,
      '',
      timerValue
    )

    if (JSON.stringify(selectedCopy) === JSON.stringify(sortedAnswerCopy)) {
      if (isEmbeded) {
        handleSucAndFailFeedback(true)
      }
    } else {
      if (isEmbeded && correct) {
        handleSucAndFailFeedback(false)
      }
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
    >
      <div
        className='row'
        style={{
          width: '100%',
          height: isEmbeded ? '50%' : undefined,
          marginTop: isEmbeded ? '0px' : '4%',
          paddingRight: isEmbeded ? undefined : '10%',
          paddingLeft: isEmbeded ? undefined : '10%'
        }}
      >
        <div className='col-md' style={{ marginRight: '10px' }}></div>
        {ColQuestion.length > 0 &&
          ColQuestion.map((columnItem, i) => {
            return (
              <div
                key={i.toString()}
                className='col-md'
                style={{
                  backgroundColor: AnswerFillColor,
                  justifyContent: isEmbeded ? TextAlign : 'center',
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '10px',
                  marginBottom: '5px',
                  borderRadius:
                    i === 0
                      ? '8px 0px 0px 0px'
                      : ColQuestion.length - 1 === i
                      ? '0px 8px 0px 0px'
                      : '0px'
                }}
              >
                <p
                  style={{
                    margin: '0px',
                    color: AnswerColorFill,
                    fontSize:
                      QuestionFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : QuestionFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    padding: '8.5px 0px 8.5px 0px',
                    fontFamily: FontStyle,
                    fontStyle: Italic ? 'italic' : 'normal',
                    fontWeight: Bold ? 'bold' : 'normal'
                  }}
                >
                  {columnItem}
                </p>
              </div>
            )
          })}
      </div>
      {RowAnswer.length > 0 &&
        RowAnswer.map((rowItem, rowIndex) => {
          return (
            <div
              key={rowIndex.toString()}
              className='row'
              style={{
                width: '100%',
                height: isEmbeded ? '100%' : undefined,
                paddingRight: isEmbeded ? undefined : '10%',
                paddingLeft: isEmbeded ? undefined : '10%'
              }}
            >
              <div
                className='col-md'
                style={{
                  width: '100%',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  height: isEmbeded ? undefined : '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: isEmbeded ? TextAlign : 'center',
                  backgroundColor: AnswerFillColor,
                  borderRadius:
                    rowIndex === 0
                      ? '8px 0px 0px 0px'
                      : RowAnswer.length - 1 === rowIndex
                      ? '0px 0px 0px 8px'
                      : '0px',
                  marginRight: '10px',
                  marginBottom: '5px',
                  padding: '0px'
                }}
              >
                <p
                  style={{
                    margin: '0px',
                    color: AnswerColorFill,
                    fontSize:
                      QuestionFontSize === 'SMALL'
                        ? SMALL_DESKTOP
                        : QuestionFontSize === 'LARGE'
                        ? LARGE_DESKTOP
                        : MEDIUM_DESKTOP,
                    fontFamily: FontStyle,
                    fontStyle: Italic ? 'italic' : 'normal',
                    fontWeight: Bold ? 'bold' : 'normal'
                  }}
                >
                  {rowItem}
                </p>
              </div>

              {ColQuestion.length > 0 &&
                ColQuestion.map((columnItem, colIndex) => {
                  return (
                    <div
                      key={colIndex.toString()}
                      className='col-md match-table-radio-cont'
                      style={{
                        height: isEmbeded ? undefined : '80px'
                      }}
                      onClick={() => {
                        if (isPractice && followTheFlow && isEmbeded) {
                          let isCorrect = false
                          if (defaultValue && defaultValue.CtlScore) {
                            if (defaultValue.CtlScore === Score) {
                              isCorrect = true
                            } else {
                              isCorrect = false
                            }
                          }
                          if (isCorrect) {
                          } else {
                            if (
                              completed === 0 &&
                              isActive &&
                              !explanationClick
                            ) {
                              handleOptionChange(rowIndex, colIndex, columnItem)
                            }
                          }
                        } else {
                          if (
                            completed === 0 &&
                            isActive &&
                            !explanationClick
                          ) {
                            handleOptionChange(rowIndex, colIndex, columnItem)
                          }
                        }
                      }}
                    >
                      <div
                        className={
                          selectedAnswerArray.length > 0
                            ? Type === 'Multiple choice'
                              ? selectedAnswerArray[rowIndex][0] === columnItem
                                ? 'match-table-radio-outer bg-white'
                                : 'match-table-radio-outer'
                              : selectedAnswerArray[rowIndex][colIndex] ===
                                columnItem
                              ? 'match-table-radio-outer bg-white'
                              : 'match-table-radio-outer'
                            : 'match-table-radio-outer'
                        }
                      >
                        <div
                          className={
                            isVerifyMode
                              ? Answers[rowIndex].includes(columnItem)
                                ? 'match-table-radio-inner-default bg-green'
                                : 'match-table-radio-inner-default bg-red '
                              : selectedAnswerArray.length > 0
                              ? Type === 'Multiple choice'
                                ? selectedAnswerArray[rowIndex][0] ===
                                  columnItem
                                  ? isPractice || completed === 1 || !isActive
                                    ? Answers[rowIndex].includes(columnItem)
                                      ? 'match-table-radio-inner-default bg-green match-bounce-in'
                                      : 'match-table-radio-inner-default bg-red match-bounce-in'
                                    : 'match-table-radio-inner-default bg-blue'
                                  : 'match-table-radio-inner-default bg-white'
                                : selectedAnswerArray[rowIndex][colIndex] ===
                                  columnItem
                                ? isPractice || completed === 1 || !isActive
                                  ? Answers[rowIndex].includes(columnItem)
                                    ? 'match-table-radio-inner-default bg-green match-bounce-in'
                                    : 'match-table-radio-inner-default bg-red match-bounce-in'
                                  : 'match-table-radio-inner-default bg-blue'
                                : 'match-table-radio-inner-default bg-white'
                              : 'match-table-radio-inner-default bg-white'
                          }
                        />
                      </div>
                    </div>
                  )
                })}
            </div>
          )
        })}
    </div>
  )
}

export default MatchTableComponent
